import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Edit from './editor.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/company/management'

export default {
  name: 'companyManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: 'PERM_ADMIN_COMPANY',
    titleI18nKey: 'admin.company.companyManagement.title.companyManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.companyManagement.title.companyManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.companyManagement.title.companyManagement'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.companyManagement.title.companyAdd'
      }
    },
    {
      path: `${basePath}/edit/:companyId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        titleI18nKey: 'admin.company.companyManagement.title.companyEdit'
      }
    }
  ]
}
